import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ActionsThatCanBeCancelled, GameAction} from '@colonist/game-base-types'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonViewWithBadge} from './UIGameActionButtonViewWithBadge'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {UIGameActionButtonPositions} from './UIGameActionsController'
import {HiddenUIElement} from '@colonist/game-beginner-mode'
import {MechanicValidatorSettlement} from '@colonist/game-mechanic-validators'
import {ActionState, CardEnum, MechanicSettlementState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameActionButtonViewSettlement extends UIGameActionButtonViewWithBadge {
    private readonly settlementValidator: MechanicValidatorSettlement

    constructor(uiGameManager: UIGameManager, settlementState: MechanicSettlementState, container: PIXI.Container) {
        const texture = UIGameSpriteHandler.getSettlementForPlayer(uiGameManager.gameController.myColor)
        const settlementValidator = new MechanicValidatorSettlement(uiGameManager.gameController.getPlayerValidators(), uiGameManager.gameController.mapValidator, settlementState)
        const settlementAmount = settlementValidator.getSettlementPlayerState(uiGameManager.gameController.myColor).bankSettlementAmount
        super(uiGameManager, UIGameActionButtonPositions.Settlement, container, settlementAmount)
        this.addCenteredIcon(texture)

        this.settlementValidator = settlementValidator

        this.setUpdateAction()
        this.stateUpdated()
        const cardsToBuildSettlement = [CardEnum.Lumber, CardEnum.Brick, CardEnum.Wool, CardEnum.Grain]
        this.setHoverAction(cardsToBuildSettlement)
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        super.buttonSpecificEvents(data, eventType)
        switch(eventType) {
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            case UIGameEventEnums.BeginnerModeInteractWithGuide: this.onBeginnerModeInteractWithGuide(data); break
            default: break
        }
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.clickedSettlementButton()
        })
    }

    private clickedSettlementButton() {
        if(this.cancelBuild()) return

        const useResources = true
        if(!this.canPerformBuyAction(this.settlementValidator.canPlayerPlaceSettlement(this.myPlayer.color, useResources))) return
        this.uiGameManager.socketGameSend.buildSettlement()
    }

    protected playerStateUpdated() {
        const settlementPlayerState = this.settlementValidator.getSettlementPlayerState(this.myPlayer.color)
        this.updateBadgeCount(settlementPlayerState.bankSettlementAmount)
    }

    protected stateUpdated() {
        this.inactivateOpacity()
        this.removeHighlight()

        const useResources = true
        if(!this.uiGameManager.gameController.isMyTurn) return
        if(!this.settlementValidator.canPlayerPlaceSettlement(this.myPlayer.color, useResources).canTakeAction) return

        this.updateOpacityForTurnState()
        this.updateHighlightForActionState()
    }

    private updateOpacityForTurnState() {
        if(!this.allowableTurnStates()) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        this.activateOpacity()
    }

    private allowableTurnStates(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Turn) return true
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase) return true

        return false
    }

    private updateHighlightForActionState() {
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceSettlement) return
        this.activateOpacity()
        this.highlight()
    }

    private cancelBuild(): boolean {
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(this.uiGameManager.gameController.currentState.actionState != ActionState.PlaceSettlement) return false

        this.uiGameManager.eventController.sendEvent([], UIGameEventEnums.SetCornerHighlight)
        this.uiGameManager.socketGameSend.cancelAction()
        return true
    }

    private onBeginnerModeActionUpdate(data: any) {
        this.setShouldRevealButton(data, HiddenUIElement.SettlementActionButton, GameAction.ConfirmBuildSettlement)
    }

    protected onBeginnerModeInteractWithGuide(data: any) {
        if(this.uiGameManager.gameController.currentState.actionState == ActionState.PlaceSettlement) return
        super.onBeginnerModeInteractWithGuide(data, GameAction.ConfirmBuildSettlement)
    }
}
